<template>
  <q-dialog
    :visible="isVisible"
    title="编辑"
    width="600px"
    :innerScroll="false"
    :loading="loadingBth"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" size="mini">
      <el-form-item label="报告名称：" prop="fileName">
        <span>{{ rowData.fileName }}</span>
      </el-form-item>
      <el-form-item label="质检时间：" prop="qualityDate">
        <el-date-picker v-model="form.qualityDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择时间" />
      </el-form-item>
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  name: 'CRUDEdit',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  data() {
    return {
      loadingBth: false,
      form: {
        qualityDate: '',
      },
      rules: {
        qualityDate: [{ required: true, message: '请选择质检时间', trigger: 'change' }],
      },
    };
  },
  mounted() {
    this.form = this.rowData;
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.loadingBth = true;
        let data = {
          taskId: this.rowData.taskId,
          qualityDate: this.form.qualityDate
        };
        this.$q.product
          .fileTaskEdit({ data: data })
          .then((res) => {
            if (res.success) {
              let text = '编辑成功';
              this.$message.success(text);
              this.isVisible = false;
              this.$emit('success');
            }
          })
          .finally((_) => {
            this.loadingBth = false;
          });
      });
    },
  },
};
</script>

<style lang="stylus" scoped></style>
